/** @jsx jsx */

import { PropsWithChildren, ReactNode } from 'react';

import { Icon } from '@zapier/zinnia-icons';
import { ModalDialogRoot, ModalDialogBody, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

import SaveButtonGroup from 'app/developer-v3/components/SaveButtonGroup';

const Styles = {
  iconWrapper: css`
    text-align: center;
  `,
};

type Props = {
  cancelButtonLabel: string;
  confirmButtonDisabled?: boolean;
  confirmButtonLabel?: string;
  description?: ReactNode;
  heading: string;
  isFailure?: boolean;
  isSaving: boolean;
  isSuccess?: boolean;
  modalProps: Object;
  onClose: () => void;
  onConfirm: () => void;
};

const VersionModalWrapper = ({
  cancelButtonLabel,
  children,
  confirmButtonDisabled,
  confirmButtonLabel,
  description,
  heading,
  isFailure,
  isSaving,
  isSuccess,
  modalProps,
  onClose,
  onConfirm,
}: PropsWithChildren<Props>) => {
  const isStatusModal = isSuccess || isFailure;
  const iconType = isSuccess ? 'formCheckCircle' : 'formXCircle';

  return (
    <ModalDialogRoot
      aria-label={heading}
      isOpen={true}
      onOpenChange={open => {
        if (!open) onClose();
      }}
      {...modalProps}
    >
      <ModalDialogBody>
        {isStatusModal && (
          <div css={Styles.iconWrapper}>
            <Icon
              color={isSuccess ? 'StatusSuccessWeaker' : 'StatusErrorWeaker'}
              name={iconType}
              size={48}
            />
          </div>
        )}
        <Text
          margin="10px 0px 20px 0px"
          tag="h1"
          textAlign={isStatusModal ? 'center' : 'inherit'}
          type="SectionHeader"
        >
          {heading}
        </Text>
        {description && typeof description === 'string' ? (
          <Text margin="10px 0px 20px 0px" tag="p" type="Body1">
            {description}
          </Text>
        ) : (
          description
        )}
        <div>{children}</div>
        <SaveButtonGroup
          cancelText={cancelButtonLabel}
          isDisabled={confirmButtonDisabled}
          isSaveButtonVisible={!!confirmButtonLabel}
          isSaving={isSaving}
          margin="20px 0 0"
          onCancel={onClose}
          onSave={onConfirm}
          saveText={confirmButtonLabel}
        />
      </ModalDialogBody>
    </ModalDialogRoot>
  );
};

VersionModalWrapper.defaultProps = {
  description: null,
  modalProps: {},
  cancelButtonLabel: 'Cancel',
};

export default VersionModalWrapper;
